/* src/app/modules_v2/finance/payment-card/components/credit-card-detail/credit-card-detail.component.scss */
:host {
  display: block;
}
.cc-panel {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(0, 1.4fr);
  gap: 16px;
}
.cc-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.cc-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.cc-card__title,
.cc-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.cc-card__title mat-icon,
.cc-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.cc-lines {
  display: flex;
  flex-direction: column;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.cc-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.cc-line + .cc-line {
  border-top: 1px solid #eef1f4;
}
.cc-line__label {
  color: #6b7280;
  white-space: nowrap;
}
.cc-line__value {
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
  min-width: 0;
}
.cc-line__value--mono {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
}
.cc-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.cc-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.cc-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.cc-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.cc-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cc-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.cc-block {
  padding: 10px 0;
}
.cc-block + .cc-block {
  border-top: 1px solid #eef1f4;
}
.cc-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.cc-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.cc-block__summary {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.cc-block__summary strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.cc-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.cc-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.cc-moves {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cc-move {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.cc-move:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.cc-move__date {
  color: #6b7280;
  white-space: nowrap;
}
.cc-move__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.cc-move__concept,
.cc-move__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cc-move__concept {
  color: #2f3540;
}
.cc-move__meta {
  font-size: 11px;
  color: #6b7280;
}
.cc-move__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cc-move__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.cc-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.cc-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cc-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.cc-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.cc-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.cc-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.cc-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.cc-block__empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 0;
}
.cc-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.cc-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.cc-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .cc-panel {
    grid-template-columns: 1fr;
  }
  .cc-kpis {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 480px) {
  .cc-move {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .cc-move__date {
    grid-column: 1/-1;
  }
}
/*# sourceMappingURL=credit-card-detail.component.css.map */
